import Env from '../../util/env';
import {serviceURL, taskApiRoutes, documentsApiExpandableItems, documentTypes} from '../../util/uiconstants';
import * as types from '../actiontypes';
import {stringify} from 'query-string';
import {getDocumentByDocumentId} from '../Ares/taskDocumentActions';

export function getDocumentAvailableTasks(engagementId, documentId, queryString) {
	let requestUrl = Env.getBaseURL(serviceURL, engagementId) + taskApiRoutes.task + '?';

	return {
		type: types.GET_DOCUMENT_AVAILABLE_TASKS,
		resolve: true,
		documentId: documentId,
		meta: {
			api: {
				url: `${requestUrl}${stringify(queryString)}`,
				method: 'GET'
			}
		}
	};
}

export function getDocumentRelatedTasks(engagementId, documentId) {
	return getDocumentByDocumentId(
		engagementId,
		documentId,
		{expand: documentsApiExpandableItems.tasks},
		_,
		_,
		types.GET_DOCUMENT_RELATED_TASKS
	);
}

export function relateTaskToDocument(engagementId, sourceEngagementId, taskId, document, supressErrorOnUi = false) {
	const url = Env.getBaseURL(serviceURL, engagementId) + taskApiRoutes.task + taskId + '/' + taskApiRoutes.document;

	const payload = {
		engagementId: engagementId,
		documentId: document.id,
		documentName: document.documentName,
		documentfileext: document.fileExt,
		taskId: taskId,
		sourceEngagementId: sourceEngagementId
	};

	return {
		type: types.RELATE_TASK_TO_DOCUMENT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		taskId,
		payload: {
			supressErrorOnUi
		}
	};
}

export function taskDocuments(engagementId, documentId, taskId, supressErrorOnUi = true) {
	const url = Env.getBaseURL(serviceURL, engagementId) + 'TaskDocuments';

	const data = {
		engagementId,
		documentId,
		taskIds: [taskId],
		targetDocumentTypeId: documentTypes.EVIDENCE,
		operationType: 1
	};

	return {
		type: types.ASSOCIATE_TASK_DOCUMENTS,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		taskId,
		payload: {
			supressErrorOnUi
		}
	};
}

export function deleteTaskDocumentRelate(engagementId, taskId, documentId, supressErrorOnUi = false) {
	const url =
		Env.getBaseURL(serviceURL, engagementId) + taskApiRoutes.task + taskId + '/' + taskApiRoutes.document + documentId;

	return {
		type: types.UNRELATE_TASK_FROM_DOCUMENT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		taskId,
		payload: {
			supressErrorOnUi
		}
	};
}
